module.exports = __webpack_public_path__ + "static/media/defaultBg2021.5bd32e52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/img/defaultBg2021.jpg
// module id = 169
// module chunks = 0